import React from 'react';
interface IconProps {
  className?: string;
  size?: number;
}
export function FlameIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-23">
      <path d="M12 2C12 2 8 6 8 10C8 12.21 9.79 14 12 14C14.21 14 16 12.21 16 10C16 6 12 2 12 2Z" fill="currentColor" opacity="0.3" data-id="element-24" />
      <path d="M12 22C7.58 22 4 18.42 4 14C4 9.58 7.58 2 12 2C16.42 2 20 9.58 20 14C20 18.42 16.42 22 12 22ZM12 4.5C9.24 7.5 6 11.5 6 14C6 17.31 8.69 20 12 20C15.31 20 18 17.31 18 14C18 11.5 14.76 7.5 12 4.5Z" fill="currentColor" data-id="element-25" />
      <path d="M12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 10 12 10C13.66 10 15 13.34 15 15C15 16.66 13.66 18 12 18Z" fill="currentColor" data-id="element-26" />
    </svg>;
}
export function CheckIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-27">
      <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor" data-id="element-28" />
    </svg>;
}
export function XMarkIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-29">
      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor" data-id="element-30" />
    </svg>;
}
export function GiftIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-31">
      <path d="M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.35C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM20 19H4V17H20V19ZM20 14H4V8H9.08L7 10.83L8.62 12L11 8.76L12 7.4L13 8.76L15.38 12L17 10.83L14.92 8H20V14Z" fill="currentColor" data-id="element-32" />
    </svg>;
}
export function ShieldIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-33">
      <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z" fill="currentColor" data-id="element-34" />
    </svg>;
}
export function ClockIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-35">
      <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="currentColor" data-id="element-36" />
    </svg>;
}
export function StarIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-37">
      <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="currentColor" data-id="element-38" />
    </svg>;
}
export function QuoteIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-39">
      <path d="M6 17H9L11 13V7H5V13H8L6 17ZM14 17H17L19 13V7H13V13H16L14 17Z" fill="currentColor" data-id="element-40" />
    </svg>;
}
export function BookIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-41">
      <path d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM6 4H11V12L8.5 10.5L6 12V4Z" fill="currentColor" data-id="element-42" />
    </svg>;
}
export function UsersIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-43">
      <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="currentColor" data-id="element-44" />
    </svg>;
}
export function CertificateIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-45">
      <path d="M4 3C2.9 3 2 3.9 2 5V15C2 16.1 2.9 17 4 17H12V22L15 20L18 22V17H20C21.1 17 22 16.1 22 15V5C22 3.9 21.1 3 20 3H4ZM4 5H20V15H16V17.88L15 17.25L14 17.88V15H4V5ZM6 7V9H14V7H6ZM16 7V9H18V7H16ZM6 11V13H10V11H6ZM12 11V13H18V11H12Z" fill="currentColor" data-id="element-46" />
    </svg>;
}
export function ChevronIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-47">
      <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" fill="currentColor" data-id="element-48" />
    </svg>;
}
export function ArrowRightIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-49">
      <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="currentColor" data-id="element-50" />
    </svg>;
}
export function WarningIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-51">
      <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="currentColor" data-id="element-52" />
    </svg>;
}
export function HeartIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-53">
      <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" fill="currentColor" data-id="element-54" />
    </svg>;
}
export function HomeIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-55">
      <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor" data-id="element-56" />
    </svg>;
}
export function PlayIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-57">
      <path d="M8 5V19L19 12L8 5Z" fill="currentColor" data-id="element-58" />
    </svg>;
}
export function FormulaIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-59">
      <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z" fill="currentColor" data-id="element-60" />
    </svg>;
}
export function TableIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-61">
      <path d="M3 3V21H21V3H3ZM9 19H5V15H9V19ZM9 13H5V9H9V13ZM9 7H5V5H9V7ZM15 19H11V15H15V19ZM15 13H11V9H15V13ZM15 7H11V5H15V7ZM19 19H17V15H19V19ZM19 13H17V9H19V13ZM19 7H17V5H19V7Z" fill="currentColor" data-id="element-62" />
    </svg>;
}
export function ModulesIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-63">
      <path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z" fill="currentColor" data-id="element-64" />
    </svg>;
}
export function VideoIcon({
  className = '',
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-65">
      <path d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z" fill="currentColor" data-id="element-66" />
    </svg>;
}